import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import api from '../../services/api';
import { loginFailure, loginRequest, loginSuccess, AuthUser } from './authSlice';

type LoginResponse = { success: boolean; token: string; user: AuthUser; message?: string };

function* handleLogin(action: PayloadAction<{ email: string; password: string }>) {
  try {
    const { data }: { data: LoginResponse } = yield call([api, api.post], '/auth/login', { ...action.payload, app: 'support' });
    if (!data.success || !data.token) {
      yield put(loginFailure(data.message || 'Sign-in failed.'));
      return;
    }
    yield put(loginSuccess({ token: data.token, user: data.user }));
  } catch (err: unknown) {
    const message = (err as { response?: { data?: { message?: string } } })?.response?.data?.message || 'Unable to reach Micus Support. Try again.';
    yield put(loginFailure(message));
  }
}

export default function* authSaga() {
  yield takeLatest(loginRequest.type, handleLogin);
}
